export default __webpack_public_path__ + "static/media/eye.c1eec281.png";